<script setup>
const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
</script>

<template>
  <article
    class="areaLink"
  >
    <h2 class="heading">
      エリアごとにゴルフ場を検索
    </h2>
    <div class="inner">
      <div
        v-for="area in areaToPrefTable"
        :key="area.key"
        class="column"
      >
        <div class="title">
          <NuxtLink
            :to="`${isWebViewFlag ? `${runtimeConfig.app.baseURL}${area.key}/` : `/${area.key}/`}`"
            :external="isWebViewFlag"
            class="title__link"
          >
            {{ area.name }}
          </NuxtLink>
        </div>
        <div class="item">
          <NuxtLink
            v-for="pref in area.pref_list"
            :key="pref.key"
            :to="`${isWebViewFlag ? `${runtimeConfig.app.baseURL}${area.key}/${pref.key}/` : `/${area.key}/${pref.key}/`}`"
            :external="isWebViewFlag"
            class="item__link"
          >
            {{ pref.name }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.areaLink {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .heading {
    font-size: 18px;
    font-weight: 600;
  }
  .inner {
    display: table;
    width: 100%;
  }
  .column {
    display: table-row;
    &:nth-child(odd) { // 背景色を奇数行につくように設定
      background-color: #F0F3F9;
    }
  }
  .title {
    display: table-cell;
    white-space: nowrap;
    padding: 8px 0 8px 10px;
  }
  .title__link {
    display: block;
    padding: 7px 10px;
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / .15);
    font-weight: 600;
    line-height: 1em;
    color: #3569c0;
    text-align: center;
  }
  .item {
    display: table-cell;
    padding: 8px 0 8px 10px;
  }
  .item__link {
    display: inline-block;
    padding: 5px 7px;
    color: #3569c0;
    font-weight: 600;
    line-height: 1em;
    text-decoration: underline;
  }
  @media (any-hover: hover) {
    .title__link {
      transition: box-shadow .2s ease-in-out;
      &:hover {
        box-shadow: 0 2px 6px 0 rgb(0 0 0 / .45);
      }
    }
    .item__link {
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
  }
}
</style>
